import React from "react";
import { withRouter } from "react-router-dom";
import EOrderOrderRequestComponent from "./EorderOrderRequest.Component";


const EOrderOrderRequestLanding = (props) => {
  return <EOrderOrderRequestComponent {...props} />
};
export default withRouter(EOrderOrderRequestLanding);
